import React, { useCallback, useEffect } from 'react';
import { Input, Tips } from '@/components';
import { Controller, useFormContext } from 'react-hook-form';
import cx from 'clsx';
import styles from './index.module.scss';
import { ErrorMessage } from '@hookform/error-message';
import { DiscordTip } from '@/assets/quest';
import { useParseInviteLink } from './hooks';
import { debounce } from 'lodash';
import { useActionLoading } from '../ActionSelect/state';

export const JoinDiscord = () => {
  const {
    control,
    formState: { errors },
    setValue,
    setError,
    watch,
  } = useFormContext();

  const url = watch('data.action_url');
  const [, setActionLoading] = useActionLoading();

  const { mutateAsync: parseTgUrl, isLoading } = useParseInviteLink();
  useEffect(() => {
    setActionLoading(isLoading);
  }, [isLoading, setActionLoading]);

  useEffect(() => {
    if (!url) {
      setActionLoading(false);
    }
  }, [setActionLoading, url]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const validateUrl = useCallback(
    debounce(async (url: string) => {
      const res = await parseTgUrl({ chatType: 'discord', inviteLink: url });
      // @ts-ignore
      if (!res?.id) {
        setValue('data.chat_name', '');
        setValue('data.id', '');
        setError('data.action_url', {
          message: 'Please input a valid Discord invite link. Eg, https://discord.com/invite/xxxxx',
        });
        return;
      }
      if (res.id && res.name) {
        setValue('data.chat_name', res.name);
        setValue('data.id', res.id);
        return true;
      }
    }, 500),
    [parseTgUrl],
  );
  return (
    <>
      <div className={styles.formItem}>
        <div className={styles.labelContainer}>
          <div className={cx(styles.label, styles.isRequired)}>Invite Link</div>
          <Tips
            placement="right"
            title={<DiscordTip className={styles.discordTip} />}
            overlayClassName={styles.discordTipContainer}
          />
        </div>
        <Controller
          control={control}
          name="data.action_url"
          render={({ field, fieldState }) => {
            return (
              <Input
                className={styles.input}
                placeholder="https://discord.com/invite/xxxxx"
                value={field?.value}
                onChange={val => {
                  field?.onChange(val);
                  setActionLoading(true);
                }}
                error={!!fieldState.error}
              />
            );
          }}
          rules={{
            required: true,
            validate: validateUrl!,
          }}
        />
        <ErrorMessage
          errors={errors}
          name={`data.action_url`}
          render={({ message }) => {
            return <div className={styles.errorMessage}>{message}</div>;
          }}
        />
      </div>
    </>
  );
};
